import { Percent } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { ConditionDatesForm } from '@retail/calculus/components';
import { TextInputField } from '@shared/components';
import { useController, useFormContext } from 'react-hook-form';
import { CreateCustomerMarkupSchema } from './customerMarkupSchema';
import { calculateToPercentage, factorFromDiscountPercent } from '@retail/utils';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { ChangeEventHandler, useCallback, useState } from 'react';
import { EnteredField } from '@retail/customer-markup/types';

export function CustomerDiscountConditionValueForm() {
  const t = useCalculusTFunction();

  const { control } = useFormContext<CreateCustomerMarkupSchema>();
  const factorController = useController({ name: 'factor', control });
  const percentController = useController({ name: 'percent', control });
  const enteredFieldController = useController({ name: 'enteredField', control });

  const [discount, setDiscount] = useState('');

  const onDiscountChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const value = e.target.value.replace(',', '.');
      setDiscount(value);
      enteredFieldController.field.onChange(EnteredField.FACTOR);

      if (Number(value) || value === '0') {
        const factor = factorFromDiscountPercent(Number(value));
        factorController.field.onChange(factor);
        percentController.field.onChange(calculateToPercentage(factor));
      } else {
        factorController.field.onChange(null);
        percentController.field.onChange(null);
      }
    },
    [enteredFieldController.field, factorController.field, percentController.field]
  );

  return (
    <Stack gap={2} pt={2}>
      <TextInputField
        name={factorController.field.name}
        value={discount}
        error={factorController.fieldState.error?.message}
        margin="none"
        required
        label={t('calculus.discounts.discount')}
        size="small"
        placeholder={t('calculus.discounts.enterDiscount')}
        endAdornment={<Percent />}
        onChange={onDiscountChange}
        onBlur={factorController.field.onBlur}
        inputSx={{ width: '245px' }}
      />
      <ConditionDatesForm excludeToDate defaultFromDate={new Date()} />
    </Stack>
  );
}
